import { Injectable } from '@angular/core';
import { get1, put } from 'src/utils/api';

export interface ExceptionQueueParams {
  pageNumber?: number;
  pageSize?: number;
  search?: string;
  exceptionType?: string;
  exceptionStatus?: string;
  referralPriority?: string;
  referralStatus?: string;
  processStatus?: string;
  assignedTo?: string;
  facilityNames?: string;
  costCenter?: string;
  fromDate?: string;
  toDate?: string;
  senderName?: string;
  senderFax?: string;
  sourceSystem?: string;
  referralTargetSystem?: string;
  sortColumn?: string;
  sortDirection?: string;
}

export interface ExceptionSummary {
  total: number;
  legalGuardian: number;
  authorization: number;
  facilityChange: number;
  missingDocs: number;
  duplicate: number;
  multiOrderManualReview: number;
  posManualReview: number;
  orderNotSupportedByFacility: number;
  other: number;
  nonReferrals: number;
  nonReferral: number;
}

@Injectable({ providedIn: 'root' })
export class ExceptionQueueService {
  private baseUrl = 'api/exceptionqueue';

  // The exception screen re-fires this on every filter/page change, auto-refresh tick and SignalR
  // push, so it passes an AbortSignal to drop the superseded call — otherwise whichever response
  // lands last wins and the grid can end up rendering rows for filters the user has moved past.
  getQueue(params: ExceptionQueueParams, signal?: AbortSignal) {
    return get1(this.baseUrl, { params, signal });
  }

  getSummary(signal?: AbortSignal) {
    return get1(`${this.baseUrl}/summary`, { signal });
  }

  updateExceptionStatus(packetId: string, exceptionStatus: string, modifiedBy: string) {
    return put(`${this.baseUrl}/${packetId}/exception-status`, { exceptionStatus, modifiedBy });
  }

  getById(packetId: string) {
    return get1(`${this.baseUrl}/${packetId}`);
  }

  // Shares getQueue's caller and grid — the screen swaps between the two as the "Non Referrals" type
  // filter goes on and off, so the caller aborts across both with a single controller.
  getNonReferrals(params: ExceptionQueueParams, signal?: AbortSignal) {
    return get1(`${this.baseUrl}/non-referrals`, { params, signal });
  }
}
